export default {"src":"/_next/static/media/icon-semiDetached.82f91e01.svg","height":26,"width":30,"blurWidth":0,"blurHeight":0};